import {
  FETCH_NOTIFICATIONS_REQUEST,
  FETCH_NOTIFICATIONS_SUCCESS,
  FETCH_NOTIFICATIONS_FAILURE,
  FETCH_ALL_NOTIFICATIONS_REQUEST,
  FETCH_ALL_NOTIFICATIONS_SUCCESS,
  FETCH_ALL_NOTIFICATIONS_FAILURE,
  MARK_NOTIFICATION_AS_READ_REQUEST,
  MARK_NOTIFICATION_AS_READ_SUCCESS,
  MARK_NOTIFICATION_AS_READ_FAILURE,
  SEND_NOTIFICATION_REQUEST,
  SEND_NOTIFICATION_SUCCESS,
  SEND_NOTIFICATION_FAILURE,
  SEND_BROADCAST_NOTIFICATION_REQUEST,
  SEND_BROADCAST_NOTIFICATION_SUCCESS,
  SEND_BROADCAST_NOTIFICATION_FAILURE,

} from './types';
import { fetchNotifications, fetchAllNotifications, markNotificationAsRead, sendNotification, sendBroadcastNotification } from "../../services/notificationService";

// Action Creators
export const fetchNotificationsRequest = () => ({ type: FETCH_NOTIFICATIONS_REQUEST });
export const fetchNotificationsSuccess = (notificationsData) => ({
  type: FETCH_NOTIFICATIONS_SUCCESS,
  payload: notificationsData,
});
export const fetchNotificationsFailure = (error) => ({
  type: FETCH_NOTIFICATIONS_FAILURE,
  payload: error,
});
export const markNotificationAsReadRequest = () => ({
  type: MARK_NOTIFICATION_AS_READ_REQUEST,
});

export const markNotificationAsReadSuccess = (notificationId) => ({
  type: MARK_NOTIFICATION_AS_READ_SUCCESS,
  payload: notificationId, // Sending the notification ID that was marked as read
});

export const markNotificationAsReadFailure = (error) => ({
  type: MARK_NOTIFICATION_AS_READ_FAILURE,
  payload: error,
});

// Actions for fetchAllNotifications
export const fetchAllNotificationsRequest = () => ({ type: FETCH_ALL_NOTIFICATIONS_REQUEST });
export const fetchAllNotificationsSuccess = (allNotificationsData) => ({
  type: FETCH_ALL_NOTIFICATIONS_SUCCESS,
  payload: allNotificationsData,
});
export const fetchAllNotificationsFailure = (error) => ({
  type: FETCH_ALL_NOTIFICATIONS_FAILURE,
  payload: error,
});

//Send
export const sendNotificationRequest = () => ({
  type: SEND_NOTIFICATION_REQUEST,
});

export const sendNotificationSuccess = (notification) => ({
  type: SEND_NOTIFICATION_SUCCESS,
  payload: notification,
});


export const sendNotificationFailure = (error) => ({
  type: SEND_NOTIFICATION_FAILURE,
  payload: error,
});

export const sendBroadcastNotificationRequest = () => ({
  type: SEND_BROADCAST_NOTIFICATION_REQUEST,
});

export const sendBroadcastNotificationSuccess = () => ({
  type: SEND_BROADCAST_NOTIFICATION_SUCCESS,
});

export const sendBroadcastNotificationFailure = (error) => ({
  type: SEND_BROADCAST_NOTIFICATION_FAILURE,
  payload: error,
});


// Thunk to fetch notifications
export const fetchNotificationsAction = (filterField, filterValue, page = 1, size = 50) => async (dispatch) => {
  dispatch(fetchNotificationsRequest());

  try {
    const response = await fetchNotifications(filterField, filterValue, page, size);

    if (response.error) {
      dispatch(fetchNotificationsFailure(response.error));
      return { success: false, error: response.error };
    } else {
      dispatch(fetchNotificationsSuccess(response));

      return { success: true, data: response };
    }
  } catch (error) {
    dispatch(fetchNotificationsFailure(error.message || "Failed to fetch notifications"));
    return { success: false, error: error.message || "Failed to fetch notifications" };
  }
};

// Thunk to fetch all notifications separately
export const fetchAllNotificationsAction = () => async (dispatch) => {
  dispatch(fetchAllNotificationsRequest());

  try {
    const response = await fetchAllNotifications();

    if (response.error) {
      dispatch(fetchAllNotificationsFailure(response.error));
      return { success: false, error: response.error };
    } else {
      dispatch(fetchAllNotificationsSuccess(response));
      return { success: true, data: response };
    }
  } catch (error) {
    dispatch(fetchAllNotificationsFailure(error.message || "Failed to fetch all notifications"));
    return { success: false, error: error.message || "Failed to fetch all notifications" };
  }
};

// Thunk to mark notification as read
export const markNotificationAsReadAction = (notificationId) => async (dispatch) => {
  dispatch(markNotificationAsReadRequest());

  try {
    const response = await markNotificationAsRead(notificationId);

    if (response.error) {
      dispatch(markNotificationAsReadFailure(response.error));
      return { success: false, error: response.error };
    } else {
      dispatch(markNotificationAsReadSuccess(notificationId));
      return { success: true, data: response };
    }
  } catch (error) {
    dispatch(markNotificationAsReadFailure(error.message || "Failed to mark notification as read"));
    return { success: false, error: error.message || "Failed to mark notification as read" };
  }
};

export const sendNotificationAction = (payload) => async (dispatch) => {
  dispatch(sendNotificationRequest());

  try {
    const response = await sendNotification(payload);

    if (response.error) {
      dispatch(sendNotificationFailure(response.error));
      return { success: false, error: response.error };
    } else {
      dispatch(sendNotificationSuccess());
      return { success: true, data: response };
    }
  } catch (error) {
    dispatch(sendNotificationFailure(error.message || "Failed to send notification"));
    return { success: false, error: error.message || "Failed to send notification" };
  }
};

export const sendBroadcastNotificationAction = (payload) => async (dispatch) => {
  dispatch(sendBroadcastNotificationRequest());

  try {
    const response = await sendBroadcastNotification(payload);

    if (response.success) {
      dispatch(sendBroadcastNotificationSuccess());
      return { success: true, data: response.data };
    } else {
      dispatch(sendBroadcastNotificationFailure(response.error));
      return { success: false, error: response.error };
    }
  } catch (error) {
    const errMsg = error.message || "Failed to send broadcast notification";
    dispatch(sendBroadcastNotificationFailure(errMsg));
    return { success: false, error: errMsg };
  }
};